import React, { useMemo } from 'react';
import clsx from 'clsx';
import { matchesX, getKeyValue } from './utils';
import styles from './styles.css.js';
export default function BarSeries(_a) {
    var _b;
    var series = _a.series, color = _a.color, xScale = _a.xScale, yScale = _a.yScale, horizontal = _a.horizontal, highlighted = _a.highlighted, dimmed = _a.dimmed, highlightedGroupIndex = _a.highlightedGroupIndex, stackedBarOffsets = _a.stackedBarOffsets, totalSeriesCount = _a.totalSeriesCount, seriesIndex = _a.seriesIndex, innerSize = _a.innerSize, chartAreaClipPath = _a.chartAreaClipPath;
    var xCoordinates = useMemo(function () {
        var _a;
        if (series.type !== 'bar' || !xScale.isCategorical()) {
            return [];
        }
        var yContinousScale = yScale.d3Scale;
        var xPoints = series.data.map(function (_a) {
            var x = _a.x;
            return xScale.d3Scale(x) || NaN;
        });
        var zeroY = (_a = yScale.d3Scale(0)) !== null && _a !== void 0 ? _a : NaN;
        var baseY = isFinite(zeroY) ? Math.min(innerSize, zeroY) : innerSize;
        var barWidth = xScale.d3Scale.bandwidth();
        var PADDING = 4;
        var MINWIDTH = 4;
        if (!stackedBarOffsets && totalSeriesCount > 1) {
            // Regular grouped bars
            barWidth = (barWidth - (totalSeriesCount - 1) * PADDING) / totalSeriesCount;
            barWidth = Math.max(barWidth, MINWIDTH);
        }
        return xPoints.map(function (x, i) {
            var _a, _b;
            var d = series.data[i];
            var barX = x;
            var yValue = d.y;
            if (stackedBarOffsets) {
                // Stacked bars
                var offsetMap = d.y < 0 ? stackedBarOffsets.negativeOffsets : stackedBarOffsets.positiveOffsets;
                yValue = d.y + (offsetMap[getKeyValue(d.x)] || 0);
            }
            else if (totalSeriesCount > 1) {
                // Regular grouped bars
                barX += seriesIndex * (barWidth + PADDING);
            }
            // Account for negative values growing "down" instead of "up"
            yValue = yValue < 0 ? yValue - d.y : yValue;
            return {
                x: barX,
                y: (_a = yContinousScale(yValue)) !== null && _a !== void 0 ? _a : NaN,
                width: barWidth,
                height: Math.abs(((_b = yContinousScale(d.y)) !== null && _b !== void 0 ? _b : NaN) - baseY)
            };
        });
    }, [series, xScale, yScale, innerSize, stackedBarOffsets, totalSeriesCount, seriesIndex]);
    var highlightedXValue = highlightedGroupIndex !== null ? xScale.domain[highlightedGroupIndex] : null;
    return (React.createElement("g", { "aria-label": series.title, clipPath: "url(#" + chartAreaClipPath + ")", className: clsx(styles.series, styles['series--bar'], (_b = {},
            _b[styles['series--highlighted']] = highlighted,
            _b[styles['series--dimmed']] = dimmed,
            _b)) }, xCoordinates.map(function (_a, i) {
        var _b;
        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        return isFinite(x) &&
            isFinite(height) && (React.createElement("rect", { key: "bar-" + i, fill: color, x: horizontal ? y - height : x, y: horizontal ? x : y, width: horizontal ? height : width, height: horizontal ? width : height, className: clsx((_b = {},
                _b[styles['series--dimmed']] = highlightedXValue !== null && !matchesX(highlightedXValue, series.data[i].x),
                _b)) }));
    })));
}
//# sourceMappingURL=bar-series.js.map